export function getView(patient_id, patient_option) {
  return patient_option === 'new' || patient_id
}
